import DarkMode from '@mui/icons-material/DarkMode';
import LightMode from '@mui/icons-material/LightMode';
import MonitorRoundedIcon from '@mui/icons-material/MonitorRounded';
import type { ComponentType } from 'react';

export type ThemeKey = 'muiDefault' | 'ACME_DARK' | 'system-appearance';

export type ThemeChoiceConfig = {
  id: string;
  value: ThemeKey;
  label: string;
  Icon: ComponentType;
};

export const THEME_CHOICES: ThemeChoiceConfig[] = [
  { id: 'theme-choice-light', value: 'muiDefault', label: 'Light', Icon: LightMode },
  { id: 'theme-choice-dark', value: 'ACME_DARK', label: 'Dark', Icon: DarkMode },
  { id: 'theme-choice-system-appearance', value: 'system-appearance', label: 'System', Icon: MonitorRoundedIcon },
];
